// @generated
// AUTO-GENERATED by scripts/generate-fhir-terminologies.ts. Do not edit.
// Run: npm run generate:terminologies
// Source: apps/ig/input/resources/code-systems/program-types.json
export const URL = 'http://alopexcare.com/fhir/CodeSystem/program-types';
export const SYSTEM = URL;
export const concepts = [
    { code: 'CCM', display: 'Chronic Care Management', displayUi: 'Chronic Care Management', system: 'http://alopexcare.com/fhir/CodeSystem/program-types' },
    { code: 'RPM', display: 'Remote Patient Monitoring', displayUi: 'Remote Patient Monitoring', system: 'http://alopexcare.com/fhir/CodeSystem/program-types' },
    { code: 'RTM', display: 'Remote Therapeutic Monitoring', displayUi: 'Remote Therapeutic Monitoring', system: 'http://alopexcare.com/fhir/CodeSystem/program-types' },
    { code: 'BHI', display: 'Behavioral Health Integration', displayUi: 'Behavioral Health Integration', system: 'http://alopexcare.com/fhir/CodeSystem/program-types' },
];
export function isValidCode(value) {
    return concepts.some((c) => c.code === value);
}
/** Returns the UI display (designation override if present, else canonical display). */
export function getDisplay(code) {
    return concepts.find((c) => c.code === code)?.displayUi ?? '';
}
/**
 * Build a FHIR Coding with the canonical display (NOT displayUi) to preserve
 * server-side terminology-binding validity. Use getDisplay() for UI rendering.
 */
export function toCoding(code) {
    const concept = concepts.find((c) => c.code === code);
    return { system: concept?.system ?? '', code, display: concept?.display ?? '' };
}
